"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.assertUnreachable = assertUnreachable;
/**
 * Asserts when compiler reaches a call to this function.
 * Use this function to assert that a switch statement is exhaustive.
 *
 * https://medium.com/technogise/type-safe-and-exhaustive-switch-statements-aka-pattern-matching-in-typescript-e3febd433a7a
 */
function assertUnreachable(_x, message = "Didn't expect to get here. assertUnreachable failed") {
    throw new Error(message);
}
//# sourceMappingURL=assert-unreachable.js.map